<div class="wil-content wil-content-listing-plan page-template-pricing">
    <section class="wil-section   bg-color-gray-2">
        <div class="container">
            <div class="row" data-col-xs-gap="20">
                <div class="wilcity-choose-listing-types">
                    <div class=" col-md-6 col-lg-6">
                        <div class="icon-box-2_module__AWd3Y wil-text-center" style="background-color: #f06292">
                            <a href="https://www.blackdirectory.co.uk/add-listing/?listing_type=listing">
                                <div class="icon-box-2_icon__ZqobK"><i class="la la-list"></i>
                                </div>
                                <h2 class="icon-box-2_title__2cgba">Add Listing</h2>
                            </a>
                        </div>
                    </div>
                    <div class=" col-md-6 col-lg-6">
                        <div class="icon-box-2_module__AWd3Y wil-text-center"
                            style="background-color: rgb(89, 224, 255)">
                            <a href="https://www.blackdirectory.co.uk/add-listing/?listing_type=event">
                                <div class="icon-box-2_icon__ZqobK"><i class="la la-calendar-o"></i>
                                </div>
                                <h2 class="icon-box-2_title__2cgba">Add Event</h2>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>